// Common header template for CardTemplate

import { useNavigate, useLocation } from 'react-router-dom';
import { useModal } from './ModalProvider';
import ImageBtns from './ImageBtns';
import './CardHeaderView.scss';

export default function CardHeaderView({
  imgUrl,
  imgThumbUrl,
  imgPath,
  imgThumbPath,
  imgTitle,
  name,
  nameCompanion,
  details,
  aside,
  allowEdit,
  onDelete,
  whatToDelete,
  placeholder,
}) {
  const navigate = useNavigate();
  const { search, hash } = useLocation();
  const { openModal } = useModal();

  // setSearchParams would drop the hash (which selects the active tab),
  // so build the search string and navigate keeping the hash
  const handleEdit = () => {
    const params = new URLSearchParams(search);
    params.set('edit', 'true');
    navigate({ search: '?' + params.toString(), hash }, { replace: true });
  };

  return (
    <div className='card-header-view'>
      <ImageBtns
        imgUrl={imgUrl}
        imgThumbUrl={imgThumbUrl}
        imgPath={imgPath}
        imgThumbPath={imgThumbPath}
        imgTitle={imgTitle}
        size={128}
        clickable
        placeholder={placeholder}
      />
      <div className='info-buttons-wrap'>
        <div className='info'>
          <div className='name-companion'>
            <h4 className='name'>{name}</h4>
            <div className='companion'>{nameCompanion}</div>
          </div>
          <div className='details'>{details}</div>
        </div>
        {aside && <div className='aside'>{aside}</div>}
        <div className='buttons'>
          {allowEdit && (
            <button className='edit small bw' onClick={handleEdit}>
              Edit
            </button>
          )}
          {onDelete && (
            <button
              className='delete small danger'
              onClick={() =>
                openModal({
                  header: `Delete ${whatToDelete}`,
                  body: (
                    <p className='font-16'>
                      {`Are you sure you want to delete the ${whatToDelete}?`}
                    </p>
                  ),
                  buttons: [
                    {
                      text: 'Cancel',
                      className: 'bw',
                    },
                    {
                      text: 'Delete',
                      className: 'danger',
                      onClick: onDelete,
                    },
                  ],
                })
              }
            >
              Delete
            </button>
          )}
        </div>
      </div>
    </div>
  );
}
